




import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";

@Component
export default class SocialLogin extends Vue {
  mounted() {
    if (!this.$gAuth.isInit) return;

    this.$gAuth?.GoogleAuth?.accounts?.id?.renderButton(
      this.$refs.googleLoginBtn,
      {
        text: "Login",
        size: "large",
        width: 366, // max width 400
        theme: "outline", // option : filled_black | outline | filled_blue
      }
    );
    this.$gAuth?.GoogleAuth?.accounts?.id?.prompt();
  }
}
